import { getQuery } from "utils/api";

// Content safety counts for the nav badge and the sign-in notice: whether
// screening is on, items waiting for review, and items blocked or removed in
// the last week. Shared per page load; the Content safety page calls
// refreshSafetySummary after a decision.
export const SAFETY_SUMMARY_EVENT = "safety-summary-changed";

const OFF = { enabled: false, review: 0, blocked: 0, removed: 0 };

let request = null;

export const fetchSafetySummary = () => {
  if (!request) {
    request = getQuery("moderation/status")
      .then((res) => {
        if (!res.data?.result?.enabled) return OFF;
        return getQuery("moderation/summary")
          .then((r) => ({ ...OFF, ...(r.data?.result || {}), enabled: true }))
          .catch(() => ({ ...OFF, enabled: true }));
      })
      .catch(() => {
        request = null;
        return OFF;
      });
  }
  return request;
};

export const refreshSafetySummary = () => {
  request = null;
  window.dispatchEvent(new Event(SAFETY_SUMMARY_EVENT));
};
